export const UNKNOWN_ERROR = {
  error: 'Unknown error',
};
